// extracted by mini-css-extract-plugin
export default {"m":"_4742f85e78","title":"_1e8f07826e","feedback_inner_title":"_83d2194c2e","textarea":"_5e0191f84a","radio":"_2466d00fe4","text":"b02488f37e"};